import style from './index.module.scss'
import template from '@styles/reusable.styles.module.scss';
import { IExpertiseCard } from '@components/main-page/main-page.state';
import { ExpertiseCard } from '@components/shared/card-types/expertise-card/expertise-card';

interface IExpertiseSectionProps {
    title: string;
    subtitle: string
    cards: IExpertiseCard[];
}


const ExpertiseSection = ({ title, subtitle, cards }: IExpertiseSectionProps) => {
    return (
        <section className={`${template.section} ${template.section_gray}`}>
            <div className={`${template.container} ${template.container_small} ${style.container}`}>
                <h2 className={`${template.title} ${style.title}`}>
                    {title}
                </h2>
                <div className={`${template.subtitle} ${style.subtitle}`}>
                    {subtitle}
                </div>
            </div>
            <div className={`${template.container} ${template.container_large} ${style.container} ${style.cards}`}>
                {
                    cards.map((item: IExpertiseCard, index: number) => {
                        return (
                            <div key={index} className={`${style.cards__item}`}>
                                <ExpertiseCard
                                  title={item.title}
                                  url={item.url}
                                  iconSrc={item.icon}
                                />
                            </div>

                        )
                    })
                }
            </div>
        </section>
    )
}

export default ExpertiseSection;
